import { render } from "./Home.vue?vue&type=template&id=66cf0bb4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=66cf0bb4&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cf0bb4"]])

export default __exports__